module.exports = __webpack_public_path__ + "static/media/Gihub.76c1edcc.svg";